import { render } from "./InquireView.vue?vue&type=template&id=e4b62cac"
import script from "./InquireView.vue?vue&type=script&lang=js"
export * from "./InquireView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__